import * as model from './model';
import * as view from './view';
import {setSpanTop, setWidthSpan} from "./model";

export default function (){
    window.JCDwsGroupToursIran = function (arParams)
    {
        this.errorCode = 0;
        this.photosTourists = null;

        this.visual = {};
        this.modalDevise = model.getModalDevise();
        this.data = {};

        if (typeof arParams === 'object')
        {
            this.params = arParams;
            this.visual = arParams['VISUAL'];
            this.data = {
                // hotelId: this.form.HOTEL.HOTEL_ID,
            };

            this.photosTourists = BX(this.visual.PHOTOS_TOURISTS_ID);
            // this.freeConsultation = this.visual.FREE_CONSULTATION_ID;


            if (!this.photosTourists) this.errorCode = -10;
            // console.log(arParams)
        }

        if (this.errorCode === 0)
        {
            BX.ready(BX.delegate(this.dwsInit, this));
        } else {
            console.error(this.errorCode)
        }
    };

    window.JCDwsGroupToursIran.prototype = {

        dwsInit: function ()
        {

            if (this.errorCode === 0)
            {
                // Карусель слайдера для мобилы
                view.initSlideOwlCarousel(this);

                // Адаптируем блоки под мобилу
                model.adaptationBlocksMobile(this.visual);

                // Отслеживаем изменение ширины экрана
                const width = document.body.clientWidth;

                // При загрузке
                model.setWidthSpan(window.screen.orientation.angle, width, this.visual);

                /*window.addEventListener('resize',() => {
                    const bodyWidth = document.body.clientWidth;

                    if (bodyWidth >= 768) {
                        model.setStylePrise(window.screen.orientation.angle, bodyWidth, this.visual);
                    } else {
                        model.setStylePrise(window.screen.orientation.angle, bodyWidth, this.visual);
                    }
                });*/
                // Отслеживаем изменение ширины экрана END


                // Клик по инпуту убираем лэйбел
                // if (this.freeConsultation) {
                //     model.formControlInput(this.freeConsultation)
                // }

            } else {
                console.error(this.errorCode)
            }
        },

    };
}